module.exports = {"id":"199964","name":"Marco Pérez","rating":"71","photo":"./data/images/photos/3/199964.png","club":{"name":"Deportes Tolima","logo":"./data/images/clubs/DeportesTolima.png"},"positions":["MD","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoPerez0.json
// module id = 2744
// module chunks = 0